export type UserPermissionsState = {
    userPermissions?: UserPermissions;
};

export const enum UserPermissionsActionTypes {
    SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS",
}

export interface UserPermissions {
    CanManageWorkflows?: boolean;
    CanManageCustomers?: boolean;
    CanManageSystemSettings?: boolean;
    CanAccessBillingInformation?: boolean;
    CanAccessReports?: boolean;
    CanAccessReportGenerator?: boolean;
    CanAccessProjects?: boolean;
    CanManageOtherPeopleVacations?: boolean;
    CanManageOwnVacations?: boolean;
    CanAccessAllTimeEntries?: boolean;
    CanAddPortfolios?: boolean;
    CanInviteUsers?: boolean;
    CanManageJobRoles?: boolean;
    CanAccessResourcePlanning?: boolean;
    CanManageHardAllocations?: boolean;
    CanCreateSpaces?: boolean;
    CanManageInvoices?: boolean;
    IsAdmin?: boolean;
}
